import React from "react";
import { useNavigate } from "react-router-dom";
import BackgroundAnimation from "../components/BackgroundAnimation";
import TextType from "../components/TextType";

function LandingPage() {
  const navigate = useNavigate();

  const handleCTSHYLogin = () => {
    navigate("/ctshy-login");
  };

  return (
    <>
      <BackgroundAnimation />
      <div className="landing-page">
        {/* <div className="logo">CLURXSAIFY.</div> */}
        <TextType
          text={["CLURXSAIFY", "for keeps, from us"]}
          typingSpeed={125}
          pauseDuration={3000}
          showCursor={true}
          cursorCharacter="|"
          className="logo"
        />
        <div className="login-buttons">
          <button className="login-button" onClick={handleCTSHYLogin}>
            clurxsaify login
          </button>
        </div>
      </div>
    </>
  );
}

export default LandingPage;
